import { Injectable } from "@angular/core";
import { UserService } from "@main-services/user.service";
import { StakingFacade } from "@modules/staking/domain/+state/staking.facade";
import { combineLatest, Observable, of } from "rxjs";
import { Feature } from "@models/feature-list";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: "root"
})
export class FeatureAvailabilityService {
	public constructor(
		private userService: UserService,
		private launchDarklyService: LaunchDarklyService,
		private stakingFacade: StakingFacade
	) {}

	public getAvailability(feature: Feature): Observable<boolean> {
		if (!this.userService.user.isVerified()) {
			return of(false);
		}

		switch (feature) {
			case Feature.CHECKOUT: {
				return this.launchDarklyService.isActive$(LD_FLAG.CHECKOUT_FLOW_ENABLED);
			}
			case Feature.STAKING: {
				return this.launchDarklyService.isFeatureActive$(LD_FLAG.STAKING_ENABLED);
			}
			case Feature.STAKING_GLOBAL: {
				return combineLatest([
					this.stakingFacade.isStakingEnabled$(),
					this.launchDarklyService.isFeatureActive$(LD_FLAG.STAKING_ENABLED)
				]).pipe(
					map(([isEnabled, isGloballyEnabled]: [boolean, boolean]) => {
						if (isEnabled === null || isGloballyEnabled === null) {
							return null;
						}
						return isEnabled && isGloballyEnabled;
					})
				);
			}
			default: {
				return of(false);
			}
		}
	}
}
